module.exports = __webpack_public_path__ + "static/media/sketch.6ddbeb2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/lifedash/src/sketch.jpg
// module id = 595
// module chunks = 0